import React from "react";
import "./SplashScreen.css";

const SplashScreen = () => {
  return (
    <div className="fxs-splashscreen">
      <div className="fxs-splashscreen-outer-ring"></div>
      <div className="fxs-splashscreen-mid-ring"></div>
      <div className="fxs-splashscreen-inner-ring"></div>
      <div className="fxs-splashscreen-logo">
        <svg width="150" height="150" viewBox="0 0 96 96">
          <defs>
            <linearGradient
              id="e399c19f-b68f-429d-b176-18c2117ff73c"
              x1="-1032.172"
              x2="-1059.213"
              y1="145.312"
              y2="65.426"
              gradientTransform="matrix(1 0 0 -1 1075 158)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#114a8b" />
              <stop offset="1" stopColor="#0669bc" />
            </linearGradient>
            <linearGradient
              id="ac2a6fc2-ca48-4327-9a3c-d4dcc3256e15"
              x1="-1023.725"
              x2="-1029.98"
              y1="108.083"
              y2="105.968"
              gradientTransform="matrix(1 0 0 -1 1075 158)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopOpacity=".3" />
              <stop offset=".071" stopOpacity=".2" />
              <stop offset=".321" stopOpacity=".1" />
              <stop offset=".623" stopOpacity=".05" />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="a7fee970-a784-4bb1-af8d-63d18e5f7db9"
              x1="-1027.165"
              x2="-997.482"
              y1="147.642"
              y2="68.561"
              gradientTransform="matrix(1 0 0 -1 1075 158)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#3ccbf4" />
              <stop offset="1" stopColor="#2892df" />
            </linearGradient>
          </defs>
          <path
            fill="url(#e399c19f-b68f-429d-b176-18c2117ff73c)"
            d="M33.338 6.544h26.038l-27.03 80.087a4.152 4.152 0 0 1-3.933 2.824H8.149a4.145 4.145 0 0 1-3.928-5.47L29.404 9.368a4.152 4.152 0 0 1 3.934-2.825z"
          />
          <path
            fill="#0078d4"
            d="M71.175 60.261h-41.29a1.911 1.911 0 0 0-1.305 3.309l26.532 24.764a4.171 4.171 0 0 0 2.846 1.121h23.38z"
          />
          <path
            fill="url(#ac2a6fc2-ca48-4327-9a3c-d4dcc3256e15)"
            d="M33.338 6.544a4.118 4.118 0 0 0-3.943 2.879L4.252 83.917a4.14 4.14 0 0 0 3.908 5.538h20.787a4.443 4.443 0 0 0 3.41-2.9l5.014-14.777 17.91 16.705a4.237 4.237 0 0 0 2.666.972H81.24L71.024 60.261l-29.781.007L59.47 6.544z"
          />
          <path
            fill="url(#a7fee970-a784-4bb1-af8d-63d18e5f7db9)"
            d="M66.595 9.364a4.145 4.145 0 0 0-3.928-2.82H33.648a4.146 4.146 0 0 1 3.928 2.82l25.184 74.62a4.146 4.146 0 0 1-3.928 5.472h29.02a4.146 4.146 0 0 0 3.927-5.472z"
          />
        </svg>
      </div>
      <div className="fxs-splashscreen-loader-container fxs-splashscreen-inner-ring">
        <div className="fxs-fabric-loading-spinner"></div>
      </div>
      <div className="fxs-splashscreen-mid-ring"></div>
      <div className="fxs-msftlogo fxs-splashscreen-outer-ring">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100.46 22.68">
          <path
            d="M41.7,5V17.67H39.5V7.74h0l-3.93,9.93H34.08l-4-9.93h0v9.93H28V5h3.15l3.64,9.39h.05L38.68,5Zm1.84,1a1.17,1.17,0,0,1,.39-.89,1.31,1.31,0,0,1,.91-.35,1.3,1.3,0,0,1,.94.36,1.19,1.19,0,0,1,.37.88,1.17,1.17,0,0,1-.38.88,1.33,1.33,0,0,1-.93.35,1.28,1.28,0,0,1-.92-.36A1.17,1.17,0,0,1,43.54,6ZM45.9,8.59v9.08H43.76V8.59Zm6.49,7.52a3,3,0,0,0,1-.22,4.75,4.75,0,0,0,1.06-.58v2a4.19,4.19,0,0,1-1.17.45,6.25,6.25,0,0,1-1.42.15,4.33,4.33,0,0,1-4.52-4.51,5.17,5.17,0,0,1,1.29-3.61,4.64,4.64,0,0,1,3.63-1.41,5.07,5.07,0,0,1,1.21.15,3.9,3.9,0,0,1,1,.36v2.05a4.27,4.27,0,0,0-1-.56,2.72,2.72,0,0,0-1-.2,2.67,2.67,0,0,0-2,.82,3.1,3.1,0,0,0-.78,2.22,2.94,2.94,0,0,0,.75,2.14A2.71,2.71,0,0,0,52.39,16.11Zm8.19-7.67a3.13,3.13,0,0,1,.46,0,1.48,1.48,0,0,1,.35.09v2.16a2.05,2.05,0,0,0-.49-.23,2.6,2.6,0,0,0-.79-.11,1.68,1.68,0,0,0-1.33.66,3.19,3.19,0,0,0-.54,2v4.59H56.1V8.59h2.14V10h0a2.5,2.5,0,0,1,.88-1.17A2.45,2.45,0,0,1,60.58,8.44Zm.92,4.82a5,5,0,0,1,1.27-3.57,4.69,4.69,0,0,1,3.54-1.32,4.36,4.36,0,0,1,3.32,1.27,4.79,4.79,0,0,1,1.2,3.42,4.85,4.85,0,0,1-1.27,3.52,4.64,4.64,0,0,1-3.47,1.31,4.57,4.57,0,0,1-3.35-1.24A4.62,4.62,0,0,1,61.5,13.26Zm2.23-.07a3.23,3.23,0,0,0,.64,2.17,2.31,2.31,0,0,0,1.85.75A2.13,2.13,0,0,0,68,15.36a3.45,3.45,0,0,0,.61-2.23A3.37,3.37,0,0,0,68,10.92a2.18,2.18,0,0,0-1.77-.74,2.23,2.23,0,0,0-1.82.78A3.35,3.35,0,0,0,63.73,13.19ZM74,11a.92.92,0,0,0,.29.72,5.1,5.1,0,0,0,1.29.66,4.4,4.4,0,0,1,1.8,1.15,2.41,2.41,0,0,1,.51,1.55,2.49,2.49,0,0,1-1,2.06,4.19,4.19,0,0,1-2.66.78A6.46,6.46,0,0,1,73,17.75a5.63,5.63,0,0,1-1.17-.35V15.3a5.34,5.34,0,0,0,1.26.64,3.65,3.65,0,0,0,1.22.24,2.25,2.25,0,0,0,1.07-.2.72.72,0,0,0,.34-.68,1,1,0,0,0-.36-.75,5.32,5.32,0,0,0-1.35-.7,4.21,4.21,0,0,1-1.68-1.11,2.47,2.47,0,0,1-.5-1.58,2.48,2.48,0,0,1,1-2,3.87,3.87,0,0,1,2.53-.79,6.09,6.09,0,0,1,1.07.1,4.36,4.36,0,0,1,1,.28v2a4.57,4.57,0,0,0-1-.49,3.44,3.44,0,0,0-1.12-.2,1.63,1.63,0,0,0-1,.24A.74.74,0,0,0,74,11Zm4.81,2.29a5,5,0,0,1,1.27-3.57,4.69,4.69,0,0,1,3.54-1.32A4.35,4.35,0,0,1,87,9.64a4.79,4.79,0,0,1,1.2,3.42,4.81,4.81,0,0,1-1.27,3.52,5.2,5.2,0,0,1-6.82.07A4.62,4.62,0,0,1,78.82,13.26Zm2.23-.07a3.23,3.23,0,0,0,.64,2.17,2.31,2.31,0,0,0,1.85.75,2.13,2.13,0,0,0,1.77-.75,3.45,3.45,0,0,0,.61-2.23,3.37,3.37,0,0,0-.63-2.21,2.18,2.18,0,0,0-1.77-.74A2.23,2.23,0,0,0,81.7,11,3.35,3.35,0,0,0,81.05,13.19Zm14.19-2.86H92.06v7.34H89.89V10.33H88.37V8.59h1.52V7.32A3.11,3.11,0,0,1,90.83,5a3.25,3.25,0,0,1,2.38-.92,6.77,6.77,0,0,1,.69,0,3.22,3.22,0,0,1,.53.12V6.07a2.24,2.24,0,0,0-.37-.15,1.87,1.87,0,0,0-.61-.09,1.29,1.29,0,0,0-1,.42,1.85,1.85,0,0,0-.36,1.24v1.1h3.18v-2l2.15-.65v2.7h2.16v1.74H97.39v4.25a1.83,1.83,0,0,0,.3,1.19,1.24,1.24,0,0,0,1,.34A1.48,1.48,0,0,0,99.1,16a2.35,2.35,0,0,0,.45-.21v1.77a3,3,0,0,1-.67.21,5.09,5.09,0,0,1-.94.1,2.63,2.63,0,0,1-2-.72A3.08,3.08,0,0,1,95.24,15Z"
            fill="#737373"
          />
          <rect x="0.55" y="0.78" width="10.03" height="10.03" fill="#f25022" />
          <rect
            x="11.63"
            y="0.78"
            width="10.03"
            height="10.03"
            fill="#7fba00"
          />
          <rect
            x="0.55"
            y="11.85"
            width="10.03"
            height="10.03"
            fill="#00a4ef"
          />
          <rect
            x="11.63"
            y="11.85"
            width="10.03"
            height="10.03"
            fill="#ffb900"
          />
        </svg>
      </div>
    </div>
  );
};

export default React.memo(SplashScreen);
